import "../../../../styles/page/shoppingCart.scss";
import "../../../../styles/editListCartComponent.scss";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Icon, { iconColor, iconTypes } from "../../../common/components/Icon.jsx";
import { SubMenu, SubMenuItem } from "../../../common/components/SubMenu.jsx";
import { Tag, tagTypes } from "../../../common/components/Tag.jsx";
import { getPropertyValue, isPropertyValueChanged } from "../../../common/util/changeUtils.jsx";

import AddRemoveField from "../../../common/components/AddRemoveField";
import EmptyEditListCart from "../order/EmptyEditListCart";
import LabelField from "../../../common/components/LabelField.jsx";
import Loading from "../../../common/components/Loading.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import { ProductViewListItem } from "../product/ProductViewListItem.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";
import Scroll from "../../../common/components/Scroll";
import TextFieldActive from "../../../common/components/TextFieldActive";
import YesNoModal from "../../../common/components/YesNoModal.jsx";
import { scssVariables } from "../../../common/util/config.jsx";
import { withRouter } from "react-router-dom";

class EditListCart extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            expanded: this.props.deviceType!=="xs",
        };

        this.getDropDownDateStyle = this.getDropDownDateStyle.bind(this);

        this.onDragEnd = this.onDragEnd.bind(this);

        this.calculateListHeight = this.calculateListHeight.bind(this);
        this.onDeleteMyList = this.onDeleteMyList.bind(this);
        this.onClickExpand = this.onClickExpand.bind(this);
        this.onClickMinimize = this.onClickMinimize.bind(this);
        this.prepareShoppingCart = this.prepareShoppingCart.bind(this);
        this.onClickDeleteList = this.onClickDeleteList.bind(this);
        this.closeListModal = this.closeListModal.bind(this);
        this.onClickCancelEdit = this.onClickCancelEdit.bind(this);
        this.onEditName = this.onEditName.bind(this);
        this.swapReplacedProduct = this.swapReplacedProduct.bind(this);
    }

    getDropDownDateStyle() {
        const {
            width,
            deviceType,
        } = this.props;
        const {
            expanded
        } = this.state;

        //calender max current max size is 450
        return (deviceType==="xs" && {
            width: `${Math.min(450, Math.max(parseInt(scssVariables.minDeviceWidth),width))}px`,
            top: expanded?undefined:"-381px",
        }) || (deviceType==="sm" && {
            width: `${Math.min(450,width-parseInt(scssVariables.shoppingCartWidthTiny)+parseInt(scssVariables.cardMargin)+parseInt(scssVariables.menuHeight))}px`,
            left: `-${Math.min(390,width-parseInt(scssVariables.shoppingCartWidthTiny)+parseInt(scssVariables.cardMargin))}px`,
        } || {
            width: "450px",
            left: "-390px"//450-subMenuItemWidth
        });
    }

    onClickExpand() {
        this.setState({
            expanded: true,
        });
    }
    onClickMinimize() {
        this.setState({
            expanded: false,
        });
    }
    onClickDeleteList() {
        const {
            localization,
            setModal,
            editingList,
        } = this.props;
        setModal(<YesNoModal
            localization={localization}
            onYes={this.onDeleteMyList}
            onNo={this.closeListModal}
            onCancel={this.closeListModal}
            onCloseModal={this.closeListModal}
            labelHeader={localization.text("list","areYouSure")}
            label={localization.text("list","areYouSureOnDelete",{name: editingList.name})}
        />);
    }
    closeListModal(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.props.setModal(null);
    }
    onDeleteMyList(event) {
        event.stopPropagation();
        event.preventDefault();
        this.props.deleteMyList();
        this.props.setModal(null);
    }
    onClickCancelEdit() {
        this.props.history.push("/order/lists");
    }
    onEditName(change) {
        this.props.changeCustomList(change);
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        //swap places
        this.props.moveFromToInMyList(result.source.index, result.destination.index);
    }

    swapReplacedProduct(productId, replacedProductId)
    {
        const {
            swapReplacedProductInMyList,
        } = this.props;

        swapReplacedProductInMyList(productId, replacedProductId);
    } 

    calculateListHeight() {
        const {
            height,
        } = this.props;

        let listHeight = height;

        //top menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //progressbar
        listHeight -= parseInt(scssVariables.progresbarHeight);
        //second menu
        listHeight -= parseInt(scssVariables.menuHeight);
        //bottom section
        listHeight -= parseInt(scssVariables.editlistCartDetailHeight);

        return listHeight;
    }

    prepareShoppingCart() {
        const {
            deviceType,
            localization,
            addRemoveProductToTemporaryOrder,
            editingList,
            setModal,
        } = this.props;

        //shopping cart exist only in 2 sizes 320px($shopping-cart-width-tiny) or 465px($shopping-cart-width)
        const renderedForDeviceType = (deviceType==="xs" || deviceType==="sm") ? "xs" : "sm";

        const lines = getPropertyValue(editingList,"lines");

        const retNodes = [];
        retNodes.push(
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{width:"100%"}}
                        >
                            {lines && lines.map((item, index) => (
                                <Draggable key={`Un-${item.productId}`} draggableId={`Un-${item.productId}`} index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                        >
                                            <ProductViewListItem
                                                style={{
                                                    backgroundColor: snapshot.isDragging?"#e8e9eb":(index%2==0?"#f2f3f5":"#f6f7f8")
                                                }}
                                                key={`Un-${item.productId}`}
                                                localization={localization}
                                                product={item.product ||{}}
                                                deviceType={renderedForDeviceType}
                                                addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                                                list={editingList}
                                                border={false}
                                                countOnylOrdered={false}
                                                setModal={setModal}
                                                countingNode={<AddRemoveField/>}
                                                draggableIcon={true}
                                                swapReplacedProduct={this.swapReplacedProduct}
                                            />
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );

        return retNodes;
    }

    render(){
        const {
            editingList,
            localization,
            height,
            deviceType,
            UpdateMyList,
            productLists,
            listId,
        } = this.props;
        const {
            expanded
        } = this.state;

        const listHeight = this.calculateListHeight();

        const isTinyDevice = deviceType==="xs" || deviceType==="sm";

        const list = getPropertyValue(editingList,"lines");
        const listSize = list && list.length || 0;

        const isConfirming =  productLists.customListUploading;
        const canSave = productLists.customListsLoading==false && productLists.customListUploading==false && !isConfirming && listSize>0 && editingList && getPropertyValue(editingList,"name").length>0 &&
                        (isPropertyValueChanged(editingList, "name") || isPropertyValueChanged(editingList, "lines"));
        const canDelete = productLists.customListsLoading==false && productLists.customListUploading==false && editingList.myListId>0;

        const menu = (
            <SubMenu>
                <SubMenuItem interactive={false} roundCornerTopLeft={true} iconType={iconTypes.pen} dropDownStyle={this.getDropDownDateStyle()} />
                <SubMenuItem side="left-borderless" isDroppedDown={false}>
                    <div className="flex-align-center" style={{height:"100%", paddingLeft:"8px"}}>
                        <div className="cart-menu-header">
                            <div className="name-label">
                                <LabelField label={localization.text("list","editingList")} isRequired={true} />
                            </div>
                            <div style={{position:"relative", float:"left", width:isTinyDevice?"118px":"260px"}}>
                                {(editingList && editingList.name || listId===-1) && (
                                    <TextFieldActive onEdit={this.onEditName} source={editingList} property="name" invisibleBackground={true} maxLength={200}/>
                                )}
                            </div>
                        </div>
                    </div>
                </SubMenuItem>
                {deviceType==="xs" ? (
                    expanded ? (
                        <SubMenuItem side="locked-right" onClick={this.onClickMinimize} iconType={iconTypes.down} />
                    ) : (
                        <SubMenuItem side="locked-right" onClick={this.onClickExpand} iconType={iconTypes.up} />
                    )
                ) : (
                    <SubMenuItem side="locked-right" onClick={this.onClickCancelEdit} iconType={iconTypes.x} />
                ) }
            </SubMenu>
        );

        const renderCart = () => {
            return (
                <React.Fragment>
                    {menu}
                    <div className="sub-menu border flex-align-center">
                        <div className="shopping-cart-menu-info">
                            <Icon type={iconTypes.itemList} style={{marginLeft:"9px"}}/>
                            <div className="label16 shopping-cart-menu-info-text flex-align-center">
                                {localization.text("list","inYourList")}
                            </div>
                            <div className="flex-align-center">
                                { listSize>0 ? (
                                    <Tag type={tagTypes.red} label={localization.text("order","countLines",{count:listSize})}/>
                                ) : (
                                    <Tag type={tagTypes.grey} label={localization.text("order","empty")} className={"tag-large"}/>
                                )}
                            </div>
                        </div>
                    </div>
                    {listSize>0? (
                        <React.Fragment>
                            <div className={"product-view-header-wrapper"} >
                                <div style={{marginTop:"8px", marginBottom:"8px"}}>
                                    <ResponsiveRows gutters={false}>
                                        <ResponsiveColumn xs={8}>
                                            <div className="product-view-list-header" style={{textIndent:"70px"}}>
                                                {localization.text("list","headerProduct")}
                                            </div>
                                        </ResponsiveColumn>
                                        <ResponsiveColumn xs={4}>
                                            <div className="product-view-list-header" style={{width:"100%",textAlign:"right",paddingRight:"24px"}}>
                                                {localization.text("list","headerSort")}
                                            </div>
                                        </ResponsiveColumn>
                                    </ResponsiveRows>
                                </div>
                            </div>
                            <Scroll className={"shopping-cart-list-wrapper"} style={{height:`${listHeight-34}px`}}>
                                {this.prepareShoppingCart()}
                            </Scroll>
                        </React.Fragment>
                    ) : (
                        productLists.customListsLoading ? (
                            <Loading height={listHeight} width="100%" loadingSize={30} points={12} lapTime={2}/>
                        ) : (
                            <EmptyEditListCart listHeight={listHeight} localization={localization}/>
                        )
                    )}
                    <div className="editlist-cart-bottom">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={12}>
                                {canDelete ? (
                                    <button className={"btn icon"} onClick={this.onClickDeleteList}>
                                        <Icon type={iconTypes.trashBin} />
                                        {localization.text("list", "deleteList")}
                                    </button>
                                ) : (
                                    <button className="btn icon" onClick={this.onClickCancelEdit}>
                                        <Icon type={iconTypes.x} color={iconColor.red}/>
                                        {localization.text("list", "deleteList")}
                                    </button>
                                )}
                                <button className={"btn primary"} onClick={UpdateMyList}  disabled={!canSave}>
                                    {isConfirming ? localization.text("list", "savingList") : localization.text("list", "saveList")}
                                </button>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </React.Fragment>
            );
        };

        return expanded ? (
            deviceType==="xs" ? (
                <React.Fragment>
                    <div className="dim-screen" onClick={this.onClickMinimize}/>
                    <div className="shopping-cart-card-expanded-tiny" style={{height:`${height+parseInt(scssVariables.cardMargin)}px`}}>
                        {renderCart()}
                    </div>
                </React.Fragment>
            ) : (
                <div className="card-default shopping-cart-card" style={{height:`${height}px`}}>
                    {renderCart()}
                </div>
            )
        ) : (
            <div className="shopping-cart-card-tiny">
                {menu}
            </div>
        );
    }
}

EditListCart.propTypes = {
    localization: Localization.propTypes.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    moveFromToInMyList: PropTypes.func.isRequired,
    swapReplacedProductInMyList: PropTypes.func.isRequired,
    changeCustomList: PropTypes.func.isRequired,
    editingList: PropTypes.object.isRequired,
    productLists: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    deviceType: PropTypes.string.isRequired,
    width: PropTypes.number,
    deliveryDates: PropTypes.array.isRequired,
    UpdateMyList: PropTypes.func.isRequired,
    deleteMyList: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    setModal: PropTypes.func.isRequired,
    //
    listId: PropTypes.number,
};

export default withRouter(EditListCart);